/* eslint-disable no-nested-ternary */
import React, { FC } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { styled } from 'linaria/react';
import { Text } from '@shared/ui/atoms';
import { baseColors, withTheme } from '@shared/lib/theme';
import { homeTabClickGtm } from '@shared/lib/gtm/redesign';
import { NavbarItemType } from '../model/navbar.model';
import { getNavbarTabEventLabel } from '../lib/getNavbarTabEventLabel';
interface MobileNavbarButtonProps {
  isActive: boolean;
  item: NavbarItemType;
}
const MobileNavbarButton: FC<MobileNavbarButtonProps> = ({
  isActive,
  item
}) => {
  const router = useRouter();
  const handleClick = () => {
    const tab = getNavbarTabEventLabel(item.label);
    if (tab) {
      homeTabClickGtm(tab);
    }
    item.onClick?.();
  };
  const isSteamItem = item.label === 'Steam';
  const isSteamPage = router.asPath.includes('/steam');
  const hasSteamCircle = isSteamItem && !isSteamPage;
  const buttonContent = <>
      <IconWrapper isSteamPage={isSteamPage} isSteamItem={isSteamItem} isActive={isActive}>
        {hasSteamCircle && <SteamOrb />}
        {item.icon}
      </IconWrapper>
      <Text size="captionM" color={isActive ? 'accent' : 'primary'}>
        {item.label}
      </Text>
    </>;
  if (item.href) {
    return <Link href={item.href} onClick={handleClick}>
        <MobileNavbarButtonWrapper>{buttonContent}</MobileNavbarButtonWrapper>
      </Link>;
  }
  return <MobileNavbarButtonWrapper as="button" onClick={handleClick}>
      {buttonContent}
    </MobileNavbarButtonWrapper>;
};
export default MobileNavbarButton;

/**
 * Blue glint inside the Steam circle. The circle itself stays flat: same
 * `#016a99` fill, with two blurred spots drifting over it. Sits between the
 * circle (`IconWrapper::after`) and the Steam icon, clipped to the circle.
 */
const SteamOrb: FC = () => <svg className="steam-orb" viewBox="0 0 64 64" aria-hidden="true" focusable="false">
    <defs>
      <clipPath id="steam-orb-clip">
        <circle cx="32" cy="32" r="31" />
      </clipPath>
      {/* Heavy blur: a visible edge would read as a separate shape, not as a
          shift in the fill itself. */}
      <filter id="steam-orb-soft" x="-60%" y="-60%" width="220%" height="220%">
        <feGaussianBlur stdDeviation="6" />
      </filter>
    </defs>

    <g clipPath="url(#steam-orb-clip)">
      <circle cx="32" cy="32" r="31" fill="#016a99" />
      {/* Two spots of different size and speed: identical ones would move in
          step and read as a single blinking spot. */}
      <ellipse className="steam-orb__glint steam-orb__glint--a" cx="22" cy="40" rx="24" ry="17" fill="#3fd2ff" filter="url(#steam-orb-soft)" />
      <ellipse className="steam-orb__glint steam-orb__glint--b" cx="44" cy="22" rx="19" ry="14" fill="#8ceaff" filter="url(#steam-orb-soft)" />
    </g>
  </svg>;
const MobileNavbarButtonWrapper = /*#__PURE__*/styled('li')({
  name: "MobileNavbarButtonWrapper",
  class: "m1fvoox0",
  propsAsIs: false
});
interface IconWrapperProps {
  isSteamItem: boolean;
  isSteamPage: boolean;
  isActive: boolean;
}
const _exp = /*#__PURE__*/() => ({
  isSteamItem,
  isSteamPage
}) => isSteamItem && !isSteamPage ? 'relative' : 'static';
const _exp2 = /*#__PURE__*/() => ({
  isSteamItem,
  isSteamPage
}) => isSteamItem && !isSteamPage ? '12px' : '0';
const _exp3 = /*#__PURE__*/() => ({
  isSteamItem,
  isSteamPage
}) => isSteamItem && !isSteamPage ? 'block' : 'none';
const _exp4 = /*#__PURE__*/() => ({
  isSteamItem,
  isSteamPage,
  isActive,
  theme
}) => isActive ? theme.colors.background.accent : isSteamItem && !isSteamPage ? baseColors.neutral_50 : theme.colors.icon.primary;
const IconWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "i1rvnsjr",
  propsAsIs: false,
  vars: {
    "i1rvnsjr-0": [_exp()],
    "i1rvnsjr-1": [_exp2()],
    "i1rvnsjr-2": [_exp3()],
    "i1rvnsjr-3": [_exp4()]
  }
}));

require("./MobileNavbarButtonTest.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./MobileNavbarButtonTest.tsx");